export default __webpack_public_path__ + "static/media/grinScopeLGMiniInfo.1b38350a.png";